module.exports = __webpack_public_path__ + "img/dongji_ps_21.7af0ae74.jpg";